module.exports = {
  SAT: 'SAT',
  ACT: 'ACT',
  UMAT: 'UMAT',
  SAT_30_MINS: '30 Minute SAT',
  GENERAL: 'General',
};
